import React, { useCallback } from 'react';
import { Form, Input, Modal } from 'antd';
import { addToast } from '@ydistri/utils';
import { useAppDispatch } from '../../../store';

interface FormFields {
  name: string;
}

interface EditAsoModalProps {
  open: boolean;
  currentName?: string;
  onCancel: () => void;
  modalTitle: string;
  formDataType: string;
  formName: string;
  nameRequiredMessage: string;
  confirmLoading: boolean;
  onSubmit: (name: string) => PromiseLike<unknown>;
}

const formLayout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 14 },
};

const EditAsoModal: React.FC<EditAsoModalProps> = ({
  open,
  currentName,
  onCancel,
  modalTitle,
  formDataType,
  formName,
  nameRequiredMessage,
  confirmLoading,
  onSubmit,
}) => {
  const [form] = Form.useForm<FormFields>();
  const dispatch = useAppDispatch();

  const handleSubmit = useCallback(() => {
    form
      .validateFields()
      .then(values => {
        onSubmit(values.name).then(() => {
          form.resetFields();
          onCancel();
        });
      })
      .catch(() => {
        dispatch(
          addToast({
            message: 'Please check required fields',
            isError: true,
          }),
        );
      });
  }, [dispatch, form, onCancel, onSubmit]);

  return (
    <Modal
      data-type="modal"
      title={modalTitle}
      open={open}
      width={800}
      okText="Save"
      onOk={handleSubmit}
      onCancel={onCancel}
      confirmLoading={confirmLoading}
    >
      <Form
        data-type={formDataType}
        form={form}
        labelCol={formLayout.labelCol}
        wrapperCol={formLayout.wrapperCol}
        name={formName}
        layout="horizontal"
        initialValues={{ name: currentName ?? '' }}
      >
        <Form.Item
          name="name"
          label="Name"
          rules={[{ required: true, message: nameRequiredMessage }]}
        >
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EditAsoModal;
